(function () {
    'use strict';
    angular.module('Services').factory('ServiceRequestTicketsTableService', ServiceRequestTicketsTableService);

    ServiceRequestTicketsTableService.$inject = [
        'TableLiteFactory',
        'ServiceRequestTicketService',
        'toastr',
        '$filter',
        '$uibModal',
        '$location'
    ];

    function ServiceRequestTicketsTableService(
        TableLiteFactory,
        ServiceRequestTicketService,
        toastr,
        $filter,
        $uibModal,
        $location
    ) {
        return function () {
            const tableStructure = {
                tableName: 'ServiceRequestTicketsTableService',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                    noExtraction: true
                },
                optionAddOns: {
                    buttons: [{
                        class: 'btn-primary',
                        label: 'Create New Ticket',
                        onClick: () => {
                            $uibModal.open({
                                ariaLabelledBy: 'modal-title',
                                ariaDescribedBy: 'modal-body',
                                templateUrl: 'templates/pages/service-request/modal/create-service-request-ticket-modal.html',
                                controller: 'CreateServiceTicketModalController',
                                controllerAs: 'vm',
                                keyboard: false,
                                backdrop: 'static',
                                size: 'md',
                            }).result.then(res=>{
                                if(res){
                                    tableActions.sendRequest({});
                                }
                            });
                        }
                    }, {
                        class: 'btn-primary',
                        label: 'Export Issues',
                        onClick: () => {
                            // todo: add export issues code
                            ServiceRequestTicketService.export(res=>{
                                toastr.success('Successfully exported')
                            },err=>{

                            })
                        }
                    }],
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    width: '10',
                    filter: { type: 'checkbox' }
                }, {
                    label: 'Created Date',
                    viewName: 'createdDate',
                    filterName: 'createdDate',
                    width: '135px',
                    filter: {
                        type: 'datePicker',
                        class: 'filter-date',
                        useArray: true,
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Ticket No.',
                    viewName: 'ticketNumber',
                    filterName: 'ticketNumber',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Consignment No.',
                    viewName: 'consignmentNumber',
                    filterName: 'consignmentNumber',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'status',
                    filter: {
                        type: 'select2',
                        placeholder: 'Search',
                        class: 'table-input',
                        items: [{
                            value: 'OPEN',
                            viewName: 'Open'
                        }, {
                            value: 'IN_PROGRESS',
                            viewName: 'In Progress'
                        }, {
                            value: 'COMPLETED',
                            viewName: 'Completed'
                        }, {
                            value: 'CANCELLED',
                            viewName: 'Cancelled'
                        }],
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Issue Notes',
                    viewName: 'issueNotes',
                    filterName: 'issueNotes',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Category',
                    viewName: 'category',
                    filterName: 'category',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Customer',
                    viewName: 'customerName',
                    filterName: 'customerName',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                }, {
                    label: 'Assignee',
                    viewName: 'assigneeName',
                    filterName: 'assigneeName',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: (header) => {
                            tableActions.sendRequest(tableActions.evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        tableActions.sort(this.filterName);
                    }
                },
                {
                    label: 'Actions',
                    viewName: 'action',
                    class: 'text-center',
                    filter: {
                        type: 'button'
                    }
                }],
                data: []
            };

            const tableActions = new TableLiteFactory(tableStructure, {
                serviceCallback: ServiceRequestTicketService.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData();
                    toastr.error(err.message, 'Error');
                },
                defaultFilters: {
                    size: 20,
                    page: 0
                }
            });

            function buildTableData(data) {
                if (!data) { return; }
                tableActions.initializeTableData(data);
                angular.forEach(data.content, (item) => {
                    item.createdDate = $filter('bbaDate')(item.createdDate);
                    item.ticketNumber = item.ticketNumber || 'N/A';
                    item.consignmentNumber = item.consignmentNumber || 'N/A';
                    item.status = item.status || 'N/A';
                    item.issueNotes = item.issueNotes || 'N/A';
                    item.category = item.category || 'N/A';
                    item.customerName = item.customerName || 'N/A';
                    item.assigneeName = item.assigneeName || 'N/A';
                    item.action = {
                            type: 'button',
                            buttons: [{
                                text: 'View',
                                class: 'btn btn-primary btn-quirk btn-sm',
                                action: () => {
                                    $location.path(`service-tickets/view/${item.id}`)
                                }
                            }]
                        };
                    tableStructure.data.push(item);
                });
            }

            this.tableData = tableStructure;
        }
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/ServiceRequestTicketsTable.js